import React from 'react';
import { IdleCafeHeroSection } from 'organisms';

const IdleCafePage: React.FC = () => {
  return (
    <section className="detail-page detail-page--idlecafe">
      <IdleCafeHeroSection />
    </section>
  );
};

export default IdleCafePage;
